<template>
    <div class="percent-wrapper">
      <img src="@/assets/images/cup.svg" alt="cup" width="30" class="percent-image"/>
      <span class="percent-text">
        Только {{randomPercent}}% пользователей сумели пройти этот сценарий с первого
        раза!
      </span>      
    </div>
</template>

<script>
export default {
  name: 'InfoPercent',
  computed: {
    randomPercent(){
        return (Math.random() * (73 - 61) + 61).toFixed(0)
    }    
  }
}
</script>

<style>
  
</style>